import * as React from "react";
import * as _ from "lodash";
import { PatientPersonalInformation } from "@curefit/ups-common";
import {default as EditViewCard, EditViewDisplayMode} from "../../components/common/EditViewCard";
import IinfoQues from "../../models/staticData/IinfoQues";
import AppUtils, {LOADING_STATE} from "../../utils/AppUtils";
import AppLoader from "../../components/utils/AppLoader";
import {ITypeFormQuestionnaire} from "../../models/ITypeFormQuestionnaire";

/**
 * Created by Prachi on 23/03/18.
 */

interface PersonalInformationContProps {
    curefitId?: string;
    patientId?: number;
    isSelf?: boolean;
    personalInformation: PatientPersonalInformation;
    staticPersonalInfo: IinfoQues;
    fetchPatientPersonalInfo?: (curefitId: string) => any;
    savePatientPersonalInfo?: (curefitId: string, patientId: number, isSelf: boolean, patientPersonalInfo: PatientPersonalInformation) => any;
    displayMode?: EditViewDisplayMode,
    questionnaire?: ITypeFormQuestionnaire[];
    typeFormMapping?: any;
}
interface PersonalInformationContStates {
    personalInformation: PatientPersonalInformation;
    isPatientPersonalInfoDataLoaded: LOADING_STATE;
}
export default class PersonalInformationEditViewCont extends React.Component<PersonalInformationContProps, PersonalInformationContStates> {
    constructor(props: PersonalInformationContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }
    getStateFromProps = (props: PersonalInformationContProps) => {
        let currState: PersonalInformationContStates = {
            personalInformation: {},
            isPatientPersonalInfoDataLoaded: LOADING_STATE.NOT_INITIALIZED
        }
        if ( _.isNull(props.personalInformation) ) {
            props.fetchPatientPersonalInfo(this.props.curefitId);
            currState.isPatientPersonalInfoDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.personalInformation = this.props.personalInformation;
            currState.isPatientPersonalInfoDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }
    getPersonalInfoEditViewProps = () => {
        let personalInfo = {...this.state.personalInformation};
        let viewProps = {
            staticPersonalInfo: {...this.props.staticPersonalInfo},
            personalInfos: personalInfo,
            updateHandler: this.updateHandler,
            questionnaire: this.props.questionnaire,
            questionIdList: this.typeFormQuestionIdList()
        }
        let editProps = {
            staticPersonalInfo: {...this.props.staticPersonalInfo},
            personalInfos: personalInfo,
            updateHandler: this.updateHandler,
            questionnaire: this.props.questionnaire,
            questionIdList: this.typeFormQuestionIdList()
        }
        return {"view": {...viewProps}, "edit": {...editProps}};
    }
    savePersonalInfo = () => {
        // Save Patient Personal Info
        let myInstance = this;
        let savePersonalInfo: PatientPersonalInformation = this.getSaveObject();
        this.setState({isPatientPersonalInfoDataLoaded: LOADING_STATE.NOT_INITIALIZED});
        this.props.savePatientPersonalInfo(this.props.curefitId, this.props.patientId, this.props.isSelf, savePersonalInfo).then(function(){
            myInstance.setState({isPatientPersonalInfoDataLoaded: LOADING_STATE.LOADED});
        });
    }
    updateHandler = (personalProfile: PatientPersonalInformation, key: string) => {
        if (key === "goalPreferences") {
            let answers = this.props.staticPersonalInfo.questionnaire.filter(question => question.key === "goalPreferences")[0].answerList[0].values.filter(value => value.internalValue === personalProfile.goalPreferences.goalInternalValue);
            let updatedValues = answers.map(answer => { return { goalInternalValue: answer.internalValue, goalDisplayValue: answer.displayValue, meta: {} } });
            personalProfile.goalPreferences = updatedValues;
        }
        this.setState({personalInformation: personalProfile});
    }
    getSaveObject = () => {
        let personalInfo = {...this.state.personalInformation};
        return personalInfo;
    }
    cancelActionHandler = () => {}
    typeFormQuestionIdList = (): string[] => {
        let questionList = [];
        questionList = this.props.typeFormMapping.filter((item: any) => item.group === "PERSONAL_INFORMATION");
        if (!_.isEmpty(questionList)) {
            questionList = questionList.map((item: any) => item.code);
        }
        return questionList;
    }
    render() {
        let isPersonalInfoDataLoaded =  this.state.isPatientPersonalInfoDataLoaded === LOADING_STATE.LOADED;
        return <div>
            {
                isPersonalInfoDataLoaded &&
                <EditViewCard cardTitleDisplay={"Personal Information"} templateName={"personalInfo"}
                              templateProps={this.getPersonalInfoEditViewProps()}
                              lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePersonalInfo}
                              cancelActionHandler={this.cancelActionHandler}
                              displayMode={this.props.displayMode} collapsedTextPlaceholderForMobile={"personal information"} collapseInEdit={true} />
            }
            {
                !isPersonalInfoDataLoaded &&
                <AppLoader/>
            }
        </div>
    }
}